import { orderStatus } from '@/constants';
import { userGetterType } from '../user/getters';
const removeAllocateCancel = (it) => {
    const orderInfo = it.orderInfo
        .filter(({ statusCode }) => orderStatus.ALLOCATE_CANCEL.code !== statusCode);
    return {
        ...it,
        orderInfo,
    };
};
const getIsSharedWorker = (({ isDistributorUser, userDistributorId, userHubId, workerDistributorId, workerHubId, }) => {
    if (isDistributorUser) {
        return userDistributorId !== workerDistributorId;
    }
    return userHubId !== workerHubId;
});
const addIsSharedWorker = ({ isDistributorUser, userDistributorId, userHubId, }) => (it) => {
    const { group: { distributorId: workerDistributorId, hubId: workerHubId } } = it;
    const isSharedWorker = getIsSharedWorker({
        isDistributorUser,
        userDistributorId,
        userHubId,
        workerDistributorId,
        workerHubId,
    });
    return {
        ...it,
        isSharedWorker,
    };
};
const vuexGetters = {
    fulfillmentList: (state, getters, rootState, rootGetters) => {
        const isDistributorUser = rootGetters[userGetterType.isDistUser];
        const distributorId = rootGetters[userGetterType.distributorId];
        const hubId = rootGetters[userGetterType.hubId];
        return Object.values(state.fulfillmentTable)
            .map(removeAllocateCancel)
            .map(addIsSharedWorker({
            isDistributorUser,
            userDistributorId: distributorId,
            userHubId: hubId,
        }));
    },
};
export default vuexGetters;
